import React from "react";
import { View } from "react-native";

import EventSettingsScreenContainer from "@/components/EventSettingsScreenContainer";
import Callout from "@/components/settings/Callout";
import { SettingsPage } from "@/components/settings/SettingsPage";
import { useWhatsNewActions } from "@/components/whatsNew/actions";
import { useWhatsNewSession } from "@/components/whatsNew/store";
import WhatsNewList from "@/components/whatsNew/WhatsNewList";
import { t } from "@/localization";
import { useAuth } from "../../AuthContext";

// Profile › What's new (and the header button on phones and in the apps).
// Business accounts only; the feed and read state: components/whatsNew.
const WhatsNew = ({ route }) => {
  const source = route?.params?.source || "profile";
  const { profileLoaded } = useAuth();
  const wn = useWhatsNewSession(source);
  const actions = useWhatsNewActions(source);

  return (
    <EventSettingsScreenContainer
      fallbackRoute="Profile"
      loading={!profileLoaded || (wn.enabled && !wn.ready)}
    >
      <SettingsPage title={t("What's new")}>
        {profileLoaded && !wn.enabled ? (
          <Callout tone="info">
            {t("Updates about new features are shown to business accounts.")}
          </Callout>
        ) : (
          <View style={{ marginHorizontal: -12 }}>
            <WhatsNewList
              entries={wn.entries}
              fresh={wn.fresh}
              gutter={12}
              actions={actions}
            />
          </View>
        )}
      </SettingsPage>
    </EventSettingsScreenContainer>
  );
};

export default WhatsNew;
